// this URL parser can be used with access URLs returned when requesting signed upload URLs
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const parseAccessURL = (url: string) => {
  const [protocol, data] = url.split('://');
  const [bucketURL, fileName] = data.split('/');
  const bucketURLSplit = bucketURL.split('.s3.');
  const bucketName = bucketURLSplit[0];
  const region = bucketURLSplit[1];

  return {
    protocol,
    fileName,
    bucketName,
    region,
  };
};

export const getExtNameFromMIME = (mime?: string): string | undefined => {
  switch (mime) {
    case 'application/msword':
      return '.doc';
    case 'application/vnd.openxmlformats-officedocument.wordprocessingml.document':
      return '.docx';
    case 'application/pdf':
      return '.pdf';
    case 'application/vnd.ms-powerpoint':
      return '.ppt';
    case 'application/vnd.openxmlformats-officedocument.presentationml.presentation':
      return '.pptx';
    case 'text/csv':
      return '.csv';
    case 'application/vnd.ms-excel':
      return '.xls';
    case 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet':
      return '.xlsx';
    default:
      return undefined;
  }
};

export const getInitials = (name: string): string | undefined => {
  const initials = name.replace(/[^a-zA-Z- ]/g, '').match(/\b\w/g);

  return initials?.join('');
};

export default parseAccessURL;
